export const stylesLoading = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};
export const stylesLoadingTitle = {
  my: 4,
};
export const stylesLoadingContent = {
  color: 'grey.600',
};
